import { message } from "antd";
import React from "react";

type CustomMessageType = {
  content?: React.ReactNode | string;
  type?: string;
};
const CustomMessage = ({
  content = "",
  type = "success",
}: CustomMessageType) => {
  const getMsg = (type: string) => {
    switch (type) {
      case "success":
        return message.success({
          content: content,
        });
      case "error":
        return message.error({
          content: content,
        });
      case "warning":
        return message.warning({
          content: content,
        });
      default:
        return message.info({
          content: content,
        });
    }
  };
  getMsg(type);
};

export default CustomMessage;
